// Tracks whether the server answers, so the shell can show a calm "reconnecting"
// banner instead of every screen showing its own error.

class Connection {
  status = $state<'online' | 'degraded' | 'offline'>(typeof navigator !== 'undefined' && navigator.onLine === false ? 'offline' : 'online');
  private failures = 0;
  private probe: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    if (typeof window === 'undefined') return;
    window.addEventListener('online', () => this.check());
    window.addEventListener('offline', () => {
      this.status = 'offline';
    });
  }

  reportFailure() {
    this.failures += 1;
    if (navigator.onLine === false) this.status = 'offline';
    else if (this.failures >= 2) this.status = 'degraded';
    this.scheduleProbe();
  }

  reportSuccess() {
    this.failures = 0;
    this.status = 'online';
    if (this.probe) {
      clearTimeout(this.probe);
      this.probe = null;
    }
  }

  private scheduleProbe() {
    if (this.probe) return;
    this.probe = setTimeout(() => {
      this.probe = null;
      this.check();
    }, 5000);
  }

  async check() {
    try {
      const res = await fetch('/healthz', { cache: 'no-store', signal: AbortSignal.timeout(5000) });
      const ready = await fetch('/readyz', { cache: 'no-store', signal: AbortSignal.timeout(5000) }).catch(() => null);
      if (res.ok && ready?.ok) this.reportSuccess();
      else {
        this.status = 'degraded';
        this.scheduleProbe();
      }
    } catch {
      this.status = navigator.onLine === false ? 'offline' : 'degraded';
      this.scheduleProbe();
    }
  }
}

export const connection = new Connection();
